import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'

export default class ShapeTextButton extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, btnStr, bgColor, txtFont, txtSize, txtColor)
    {
        super(scene);

        this.btnId = btnStr;
        this.defaultBgColor = bgColor;

        this.btnBg = this.scene.add.graphics();
        this.add(this.btnBg);

        this.btnTxt = ABCyaPhaser.Text.addText(0, 0, txtSize, txtColor, txtFont, this.btnId, this, false).setOrigin(0);
        this.add(this.btnTxt);

        this.setBgColor(this.defaultBgColor);
        this.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(-10, 0, this.btnTxt.width + 20, this.btnTxt.height + 10),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains,
            useHandCursor: false
        });
    }

    setBgColor(color)
    {
        this.btnBg.clear();
        this.btnBg.fillStyle(color);
        this.btnBg.fillRoundedRect(-10, 0, this.btnTxt.width + 20, this.btnTxt.height + 10, 12);
        this.btnTxt.y = 5;
        this.btnBg.alpha = (color == 0) ? 0 : 1;
    }

    // original code moved the container registration point, which isn't possible in Phaser, so instead we move all the child gameobjects as needed
    centerX()
    {
        let x = -10 - ((this.btnTxt.width + 20) / 2);
        this.btnTxt.setOrigin(0.5, 0);
        this.btnBg.x = x;
        this.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(this.btnBg.x, 0, this.btnTxt.width + 20, this.btnTxt.height + 10),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains,
            useHandCursor: false
        });
    }

    // added function to center the text better
    adjustTextPosition()
    {

    }
}